import {
  Breadcrumb,
  Button,
  Container,
  Dropdown,
  Form,
  Icon,
  Label,
  Menu,
  Message,
  Popup,
  Segment,
  Select,
} from 'semantic-ui-react';
import { useEffect, useState } from 'react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { useFormik } from 'formik';
import PageContainer from '../../common/PageContainer';
import { Link } from 'react-router-dom';
import { dailyDigestStyleOptions } from '../email.constants';
import * as postApi from './../../../api/postApi';
import moment from 'moment-timezone';
import { getDateRange } from './DigestDateRange.js';
import { DateInput } from 'semantic-ui-calendar-react';
import * as yup from 'yup';
import { SERVER_URL } from '../../../constants';
import { MailTemplateSection } from '../MailTemplateSection';
import MailChimpSection from '../MailChimpSection';
import toast from 'react-hot-toast';
import * as $ from 'jquery';
import * as campaignApi from './../../../api/campaignApi';

const AddDailyDigest = ({
  sites,
  addDailyDigest,
  getSites,
  deleteDigestById,
  match,
  user,
  history,
  getDigestById,
  currentDigest,
  updateDailyDigest,
  clearRecentPosts,
  getDigestTestEmail,
  clearCurrentDigestSuccess,
  findTemplate,
}) => {
  const { id } = match.params;
  const errorStyle = { color: '#9f3a38', border: '1px solid #e0b4b4!important' };
  const [loaded, setLoaded] = useState(false);
  const [building, setBuilding] = useState(false);
  const [seriesSections, setSeriesSections] = useState([]);

  const start = moment().hour(6).minute(30).second(0).millisecond(0);
  const EMAIL_SEND_TIMES = _.range(0, 69).map(t => {
    const time = start.clone().add(t * 15, 'minutes');
    return {
      key: time.clone().add(15, 'minutes').format('hh:mm:ss A'),
      value: time.clone().add(15, 'minutes').format('hh:mm:ss'),
      text: time.clone().add(15, 'minutes').format('h:mm A'),
    };
  });

  console.log(EMAIL_SEND_TIMES);

  const tomorrow = moment().add(1, 'day').set({ hour: 6, minute: 0, second: 0 });

  yup.addMethod(yup.array, 'digestLength', function (errorMessage) {
    return this.test(`test-digest-length`, errorMessage, function (value) {
      const { path, createError } = this;
      const message = `Digests must contain 1, 3, 5, 7 or 9 posts. You currently have ${value.length} posts selected.`;
      return [1, 3, 5, 7, 9].includes(value.length) || createError({ path, message });
    });
  });

  const validationSchema = yup.object({
    style: yup.string().required('A style is required').nullable(),
    subject: yup.string().required('A subject is required').nullable(),
    siteId: yup.string().required('A site is required').nullable(),
    newsItems: yup.array().digestLength(),
    trendingEvents: yup.array().length(3, 'Trending Events must contain 3 posts'),
  });

  const UTM_MAP = {
    null: 'daily-digest',
    undefined: 'daily-digest',
    'Daily Digest': 'daily-digest',
    'Hot Headlines': 'hot-headlines',
    'Dining Report': 'dining-report',
  };

  const getUtm = style => `utm_source=${UTM_MAP[style]}&utm_medium=email&utm_campaign=website`;

  const getSeriesKeys = () => _.range(1, 11).map(idx => `series${idx}`);

  const toSeriesSection = (series, idx, fallbackSeries = []) => {
    const first = series?.[0] || {};
    const fallback = fallbackSeries?.[0] || {};
    return {
      idx,
      key: `series${idx + 1}`,
      title: first.title || fallback.title || first.headline || fallback.headline || `Series ${idx + 1}`,
      header: first.header || fallback.header,
      logo: first.logo || fallback.logo,
      values: series || [],
    };
  };

  const hydrateDynamicSeries = async digest => {
    if (!digest?.siteId || !digest?.sendDate) return;

    const built = await postApi.buildDigestForDate(digest.siteId, digest.sendDate).catch(() => null);
    const builtSeries = built?.series || [];
    if (!builtSeries.length) return;

    const series = getSeriesKeys()
      .map((key, idx) => {
        const stored = digest[key] || [];
        const values = stored.length ? stored : builtSeries[idx] || [];
        if (!stored.length && values.length) {
          formik.setFieldValue(key, values);
        }
        return toSeriesSection(values, idx, builtSeries[idx]);
      })
      .filter(s => s.values?.length);

    setSeriesSections(series);
  };

  const initialValues = {
    style: '',
    subject: '',
    newsItems: [],
    newsLinks: [],
    trendingEvents: [],
    trendingPlaces: [],
    charityEvent: '',
    charityOrganizations: [],
    series1: [],
    series2: [],
    series3: [],
    series4: [],
    series5: [],
    series6: [],
    series7: [],
    series8: [],
    series9: [],
    series10: [],
    siteId: '',
    city: '',
    property: '',
    utm: getUtm(currentDigest?.style),
    sendDate: moment().add(1, 'day').format('L'),
    sendTime: EMAIL_SEND_TIMES[0].value,
  };

  const handleSubmit = async (digest, formik) => {
    digest.id ? updateDailyDigest(digest) : addDailyDigest(digest);
  };

  const formik = useFormik({
    enableReinitialize: false,
    onSubmit: handleSubmit,
    validationSchema,
    initialValues,
    validateOnChange: false,
    validateOnBlur: false,
  });

  useEffect(() => {
    clearCurrentDigestSuccess();
    if (!id) return;
    getDigestById(id);
  }, [id]);

  useEffect(() => {
    if (currentDigest.id) {
      setLoaded(true);
      formik.setValues({ ...currentDigest });
      formik.setFieldValue('utm', getUtm(currentDigest.style));
      const keys = getSeriesKeys();

      const series = keys
        .map(key => currentDigest[key] || [])
        .map((series, idx) => toSeriesSection(series, idx))
        .filter(s => s.values?.length);

      setSeriesSections(series);
      hydrateDynamicSeries(currentDigest);
    }
  }, [currentDigest]);

  useEffect(() => {
    formik.setFieldValue('utm', getUtm(formik.values.style));

    if (formik.values.style && formik.values.siteId) {
      const template = findTemplate(formik.values.siteId, formik.values.style);
      if (template) {
        formik.setFieldValue('emailTemplateId', template.id);
      }
    }

    // forceValidation();
  }, [formik.values]);

  useEffect(() => {
    clearRecentPosts();
    // forceValidation();
  }, []);

  const sendPreviewEmail = async () => getDigestTestEmail(currentDigest.id);

  const loadPosts = async (siteId, date) => {
    if (!siteId || !date) return;
    setBuilding(true);
    const digest = await postApi.buildDigestForDate(siteId, date);
    const fields = ['newsItems', 'newsLinks', 'trendingEvents', 'trendingPlaces', ...getSeriesKeys()];
    fields.forEach(field => formik.setFieldValue(field, []));
    formik.setFieldValue('newsItems', digest?.news_items);
    formik.setFieldValue('newsLinks', digest?.news_links);
    formik.setFieldValue('trendingEvents', digest?.events);

    const subject = digest?.news_items?.length ? digest.news_items[0].headline : null;
    if (subject) {
      formik.setFieldValue('subject', $($.parseHTML(subject)).text().substring(0, 50));
    }

    const currentSeries = [];
    (digest.series || []).forEach((series, idx) => {
      const seriesKey = `series${idx + 1}`;
      formik.setFieldValue(seriesKey, series);
      currentSeries.push(toSeriesSection(series, idx));
    });

    setSeriesSections([...currentSeries]);

    setLoaded(true);
    setBuilding(false);

    formik.setErrors({});
  };

  const isValid = () => {
    try {
      validationSchema.validateSync(formik.values);
      return true;
    } catch (e) {
      return false;
    }
  };

  const getPage = () => (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to="/daily-digest">Daily Digest</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>Edit Daily Digest</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless attached="top">
        <Menu.Item header>Add daily digest</Menu.Item>
      </Menu>

      <Segment attached>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Field error={Boolean(formik.errors.style)} width={4}>
            <label htmlFor="siteId">City</label>
            <Dropdown
              search
              selection
              clearable
              options={sites?.filter(s => !s.text.includes('Map')) || []}
              id="siteId"
              label="Property"
              name="siteId"
              placeholder="Select site"
              error={Boolean(formik.errors.siteId)}
              value={formik.values.siteId || ''}
              onChange={(e, d) => {
                formik.setFieldValue('siteId', d.value);
                formik.setFieldValue('city', sites.find(site => site.key === d.value)?.text);
              }}
            />
            {formik.errors.siteId && <Label basic style={errorStyle} pointing content={formik.errors.siteId} />}
          </Form.Field>

          <Form.Field error={Boolean(formik.errors.style)} width={4}>
            <label htmlFor="style">Style</label>
            <Dropdown
              search
              selection
              clearable
              options={dailyDigestStyleOptions}
              id="style"
              data-testid="style"
              label="Style"
              name="style"
              value={formik.values.style}
              onChange={(e, d) => {
                formik.setFieldValue(d.name, d.value);
              }}
            />
            {formik.errors.style && <Label basic style={errorStyle} pointing content={formik.errors.style} />}
          </Form.Field>

          <Form.Group>
            <Form.Field width={4}>
              <label>Send date</label>
              <DateInput
                name="sendDate"
                closable={true}
                placeholder="Send date"
                value={formik.values.sendDate ? moment(formik.values.sendDate, 'YYYY-MM-DD').format('L') : ''} //
                initialDate={tomorrow}
                popupPosition="bottom center"
                dateFormat={'L'}
                iconPosition="left"
                onChange={(e, { value }) => {
                  const date = moment(value, 'MM/DD/YYYY');
                  formik.setFieldValue('sendDate', date.format('YYYY-MM-DD'));
                  if (date.day() === 6) {
                    formik.setFieldValue('style', 'Hot Headlines');
                  }
                  if (date.day() === 0) {
                    formik.setFieldValue('style', 'Dining Report');
                  }
                  if (date.day() !== 0 && date.day() !== 6) {
                    formik.setFieldValue('style', 'Daily Digest');
                  }
                }}
              />
            </Form.Field>
            <Form.Field width={4}>
              <label>Send time</label>

              <Select
                options={EMAIL_SEND_TIMES}
                id="sendTime"
                name="sendTime"
                clearable
                value={formik.values.sendTime}
                error={Boolean(formik.errors.sendTime)}
                onChange={(e, { value }) => formik.setFieldValue('sendTime', value ? value : null)}
              />

              {formik.errors.sendTime && <Label basic style={errorStyle} pointing content={formik.errors.sendTime} />}
            </Form.Field>

            <Form.Field>
              <Button
                onClick={() => loadPosts(formik.values.siteId, formik.values.sendDate)}
                content="Load posts"
                type="button"
                labelPosition="left"
                positive
                loading={building}
                disabled={!formik.values.siteId}
                icon="refresh"
                style={{ marginTop: 22 }}
                floated="right"
              />
            </Form.Field>
          </Form.Group>

          {loaded && (
            <Form.Field width={6}>
              <TextField
                name="subject"
                formik={formik}
                value={formik.values.subject || ''}
                onChange={e => {
                  if (e?.target?.value) {
                    e.target.value = $($.parseHTML(e.target.value)).text().substring(0, 50);
                  }
                  formik.handleChange(e);
                }}
                error={Boolean(formik.errors.subject)}
                errorMessage={formik.errors.subject}
                label={`Subject line (Characters: ${formik.values?.subject?.length || 0})`}
              />
            </Form.Field>
          )}
        </Form>

        <br />

        <Message>
          <Icon name="calendar alternate outline" />
          {getDateRange(formik.values.sendDate)?.description}
        </Message>
      </Segment>

      {loaded && formik?.values?.newsItems?.length > 0 && (
        <>
          <MailTemplateSection
            loading={building}
            title="News Items"
            section="newsItems"
            contentType="page,image,video,article"
            formik={formik}
            maxLength={9}
          />
          <MailTemplateSection
            loading={building}
            title="'Plus' News Links"
            section="newsLinks"
            contentType="page,image,video,article"
            formik={formik}
            maxLength={3}
          />
          {seriesSections.map((section, idx) => (
            <MailTemplateSection
              key={idx}
              title={section.title}
              section={section.key}
              formik={formik}
              header={section.header}
              logo={section.logo}
              contentType="page,image,video,article"
              maxLength={2}
            />
          ))}
          <MailTemplateSection
            loading={building}
            title="Trending Events"
            section="trendingEvents"
            formik={formik}
            contentType="event"
            maxLength={3}
          />

          <Container fluid>
            <Button
              icon="save"
              content="Save"
              positive
              labelPosition="left"
              // disabled={!formik.isValid || formik.isSubmitting}
              onClick={async () => {
                formik.validateForm().then(err => {
                  if (err && Object.keys(err).length > 0) {
                    toast.error('Please fix errors before saving');
                  } else {
                    formik.submitForm();
                    setTimeout(() => history.push('/daily-digest'), 2000);
                  }
                });
              }}
            />

            <Button
              icon="save"
              content="Save and continue editing"
              labelPosition="left"
              positive
              // disabled={!formik.isValid || formik.isSubmitting}
              onClick={() => {
                formik.validateForm().then(err => {
                  if (err && Object.keys(err).length > 0) {
                    toast.error('Please fix errors before saving');
                  } else {
                    formik.submitForm();
                  }
                });
              }}
            />

            <Button
              icon="binoculars"
              content="Save and Preview"
              target="_blank"
              labelPosition="left"
              positive
              disabled={!isValid()}
              onClick={async () => {
                formik.validateForm().then(err => {
                  if (err && Object.keys(err).length > 0) {
                    toast.error('Please fix errors before previewing');
                  } else {
                    formik.submitForm();
                    setTimeout(() => {
                      const url = `${SERVER_URL}/api/daily-digest/email/${formik.values.id}`;
                      window.open(url, '_blank');
                    }, 2000);
                  }
                });
              }}
            />

            <Button
              icon="envelope"
              labelPosition="left"
              content="Send Test Email"
              disabled={!isValid()}
              onClick={async () => {
                formik.validateForm().then(err => {
                  if (err && Object.keys(err).length > 0) {
                    toast.error('Please fix errors before previewing');
                  } else {
                    formik.submitForm();
                    setTimeout(() => {
                      sendPreviewEmail(formik.values.id);
                    }, 2000);
                  }
                });
              }}
            />

            <Button
              icon="envelope"
              labelPosition="left"
              disabled={!isValid() || !formik.values.sendTime}
              content="Schedule"
              onClick={async () => {
                formik.setFieldValue('isScheduled', true);
                formik.validateForm().then(err => {
                  if (err && Object.keys(err).length > 0) {
                    toast.error('Please fix errors before saving');
                  } else {
                    formik.submitForm();
                  }
                });
              }}
            />

            <Popup
              closeOnPortalMouseLeave
              trigger={<Button content="Delete" labelPosition="left" negative floated="right" icon="trash" />}
              content={
                <Button
                  color="green"
                  content="Are you sure?"
                  onClick={() => {
                    campaignApi.unschedule(id).then(() => {
                      deleteDigestById(id);
                    });
                  }}
                />
              }
              on="click"
              position="bottom left"
            />
          </Container>

          <br />
          <MailChimpSection id={id} user={user} formik={formik} />
        </>
      )}
    </PageContainer>
  );

  return id ? <>{currentDigest?.id && getPage()}</> : <>{getPage()}</>;
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  cities: selectors.getCityOptions(state),
  sites: selectors.admin.cultureMapSiteOptions(state),
  topPostResults: selectors.getTopPosts(state),
  searchPostResults: selectors.getSearchPosts(state),
  currentDigest: selectors.getCurrentDigest(state),
  dayOptions: selectors.getDayOptions(state),
  user: selectors.users.current(state),
  series: selectors.series.series(state),
  findTemplate: selectors.templates.find(state),
});

const mapDispatchToProps = dispatch => ({
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  clearCurrentDigestSuccess: bindActionCreators(actions.campaign.clearCurrentDigestSuccess, dispatch),
  addDailyDigest: bindActionCreators(actions.campaign.addDailyDigest, dispatch),
  updateDailyDigest: bindActionCreators(actions.campaign.updateDailyDigest, dispatch),
  getTopPosts: bindActionCreators(actions.campaign.getTopPosts, dispatch),
  searchPosts: bindActionCreators(actions.campaign.searchDigests, dispatch),
  getDigestById: bindActionCreators(actions.campaign.getDigestById, dispatch),
  getSeries: bindActionCreators(actions.series.getSeries, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  deleteDigestById: bindActionCreators(actions.campaign.deleteDigestById, dispatch),
  getDigestTestEmail: bindActionCreators(actions.campaign.getDigestTestEmail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDailyDigest);
